import React from 'react'
import styled from 'styled-components'
import { Grid, Row, Col } from 'rsuite'
import { motion } from 'framer-motion'
import Layout from '../../components/Layout'
import ContactCard from './ContactCard'
import { useRequest } from '../../fetchboi/hooks'
import { useCongress } from '../../congress/hooks'
import { useHistory  } from 'react-router-dom'

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05
    }
  }
}

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  }
}

export default function Contact () {
  const [contacts, loading] = useRequest({ url: '/messages/contacts' })
  const { generateLink } = useCongress()
  let history = useHistory()

  React.useEffect(()=>{
    function checkContact() {
      if(contacts && contacts.length === 1) {
        history.push(generateLink(`/contact/${contacts[0].UUID}&${contacts.length}`)) 
      }
    }
    checkContact()
  },[contacts])

  return (
    <Layout.Container>
      <Container>
        <Layout.Title>Contacto</Layout.Title>
          <Layout.Loader loading={loading}/>
          {contacts ? (
            <Grid fluid>
              <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <Row gutter={24}>
                  {contacts.map((contact, index) => (
                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                      <motion.div variants={itemVariants}>
                        <ContactCard
                          key={contact.UUID}
                          uuid={contact.UUID}
                          name={contact.Name}
                          multiple={contacts.length}
                        />
                      </motion.div>
                    </Col>
                  ))}
              </Row>
            </motion.div>
          </Grid>
        ) : null}
      </Container>
    </Layout.Container>
  )
}

const Container = styled.div`
  
`